// extracted by mini-css-extract-plugin
module.exports = {"passages":"ChatScreen-module__passages___28C31","incomingMessage":"ChatScreen-module__incomingMessage___Wovcf","outgoingMessage":"ChatScreen-module__outgoingMessage___3OCCJ"};